import * as React from 'react';
import * as ReactDOM from 'react-dom';
import './index.css';
import { unregister } from './registerServiceWorker';
import { Provider } from "react-redux";
import storeFactory from './store'
import App from './components/containers/App';

const store = storeFactory();
ReactDOM.render(
  <Provider store={store}>
    <App/>
  </Provider>,
  document.getElementById('root') as HTMLElement
);
unregister();
